// extracted by mini-css-extract-plugin
export default {"scaleOptionsContainer":"styles_scaleOptionsContainer__yWsLz"};